import React from "react";
import {Spin} from 'antd';
const CircularProgress = ({className,height}) => <div className={`loader ${className}`} style={{height:height?height:'100vh'}}>
  <Spin size="large" />
</div>;
export default CircularProgress;
